module.exports = __webpack_public_path__ + "img/classic1.cc289f3c.png";